import script from "./PhysicalChannel.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhysicalChannel.vue?vue&type=script&lang=ts&setup=true"

import "./PhysicalChannel.vue?vue&type=style&index=0&id=372d6754&scoped=true&lang=less"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-372d6754"]])

export default __exports__